import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '../store/queryHooks';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const me = useMe();
  if (me.isPending) {
    return <div style={{ padding: 40 }}>Indlæser…</div>;
  }
  if (me.isError || !me.data) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
